import { Component, OnInit } from '@angular/core';
import { User } from '../login/login.model';
import { BrandingMessages, Servicesoffered, ThemeConfig } from '../../../appconfig';
import { Router } from '@angular/router';
import { CommonService, RestService } from '../../services/common';
import { JwtService } from '../jwtservice';
import { ThemeService } from '../../services/common/theme.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthSessionService } from '../auth-session.service';

@Component({
  selector: 'app-developer',
  templateUrl: './developer.component.html',
  styleUrl: './developer.component.scss'
})
export class DeveloperComponent implements OnInit {
  loginUserData: User = { email: '', password: '' };
  errorMessage: string = '';
  show_button: Boolean = false;
  show_eye: Boolean = false;
  requiredRoles: any;
  userRoles: any;
  currentHostA2G: any;
  copyrightMessage: string = BrandingMessages.copyrightMessage;
  servicesOffering: string[] = Servicesoffered.DeveloperServices;
  backgroundClass: string = 'back-img-aggregator'; // default class

  defaultTheme: ThemeConfig = {
    primaryBackgroundColor: '#BA141A',
    secondaryBackgroundColor: '#ffffff',
    primaryFontColor: '#000000',
    secondaryFontColor: '#ffffff',
    logoUrl: '',
    organizationName: window.location.origin.toLowerCase().indexOf('a2g') > -1 ? 'DocuMap' : 'ERP'
  };

  constructor(
    private router: Router,
    private restService: RestService,
    private commonService: CommonService,
    private jwtService: JwtService,
    private themeService: ThemeService,
    private authSessionService: AuthSessionService
  ) {
    //just after logout or session expired login component will render and initially
    // local storage will be clear here before initializing login component
    // BUT preserve returnUrl if it exists (set by AuthGuard before redirect)
    const returnUrl = localStorage.getItem('returnUrl');
    localStorage.clear();
    //except return url all other values must be clear.
    //as return url must have been set by authgaurd if direct url was hit
    if (returnUrl) {
      localStorage.setItem('returnUrl', returnUrl);
    }
  }

  ngOnInit() {
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('aggregator')) {
      this.backgroundClass = 'back-img-aggregator';
    } else if (currentUrl.includes('developer')) {
      this.backgroundClass = 'back-img-developer';
    }

    if (window.location.origin.toLowerCase().indexOf('a2g') > -1) {
      this.currentHostA2G = true;
    };
  }

  //Function
  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }

  /**
   * Authenticates the user, stores the JWT token, then:
   * 1. Immediately updates roles from the token and navigates to the first accessible route.
   * 2. In parallel (non-blocking), fires AuthSessionService.initializeUserSession() which:
   *    - Applies org theme immediately (org details from login response — no extra API call)
   *    - Fetches sites, projects, explorations via forkJoin
   */
  Submit() {
    this.restService.postData('Login', this.loginUserData).subscribe(data => {

      // --- Step 1: Store token and essential identity info ---
      this.commonService.setLocalStorageValue('mbcrm/token', data?.result?.token);
      this.commonService.setLocalStorageValue('userId', data?.result?.userDetail?.id);
      this.commonService.setLocalStorageValue('CRM', 'true');

      // Cache lightweight user details
      this.authSessionService.cacheUserDetails(data);

      // --- Step 2: Refresh roles from the new token immediately ---
      // (roles are embedded in the JWT, no extra API call needed)
      this.jwtService.updateUserRolesFromToken();
      this.userRoles = this.jwtService.currentUserRolesValue;

      // --- Step 3: Kick off background session init (non-blocking) ---
      // org details & userGroup come from login response (lightweight — single record each)
      // sites, projects, explorations are fetched in parallel via forkJoin inside the service
      const orgDetails = data?.result?.userDetail?.organizationDetails;
      const userGroup = data?.result?.userDetail?.userGroupDetails;
      this.authSessionService.initializeUserSession(
        data?.result?.userDetail?.id,
        orgDetails,
        userGroup
      );

      // --- Step 4: Determine and navigate to the initial route ---
      const returnUrl = this.commonService.getValueFromLocalStorage('returnUrl');
      let navigationUrl: string = '';
      let isReturnUrl: boolean = false;

      if (returnUrl) {
        navigationUrl = returnUrl;
        isReturnUrl = true;
      } else {
        const firstAccessible = this.commonService.getFirstAccessibleSubMenu(this.userRoles) || '/projects';
        navigationUrl = Array.isArray(firstAccessible) ? firstAccessible[0] : firstAccessible;
      }

      if (returnUrl) {
        localStorage.removeItem('returnUrl');
      }

      if (!navigationUrl) {
        navigationUrl = '/projects'; // Fallback to projects
      }

      if (isReturnUrl) {
        this.router.navigateByUrl(navigationUrl);
      } else {
        this.router.navigate([navigationUrl]).then(() => {
          const currentRoute = this.router.routerState.snapshot.root.children.find(route =>
            route.routeConfig?.path === (navigationUrl as string).replace('/', '')
          );
          this.requiredRoles = currentRoute?.data?.['roles'];
          if (!this.requiredRoles || this.requiredRoles.some((role: any) => this.userRoles.includes(role))) {
            // User has required roles — stay on page
          } else {
            const firstAccessible = this.commonService.getFirstAccessibleSubMenu(this.userRoles) || '/projects';
            const fallbackUrl = Array.isArray(firstAccessible) ? firstAccessible[0] : firstAccessible;
            this.router.navigate([fallbackUrl]);
          }
        });
      }

    }, error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        this.errorMessage = 'Invalid username or password.';
      } else {
        this.errorMessage = 'An error occurred during login.';
      }
    });
  }
}
